export const getUserBrokers = `query getUser{
  getUser{
      brokers{
          name
          email
          phone
          img
      }
  }
}`;
